import React from 'react'
import ComapanyVerif from '../../../features/CompVerif/CompVerif'

function CompVerifPage() {
  return (
    <div>
      <ComapanyVerif/>
      {/* <ComapanyVerif2/> */}
    </div>
  )
}

export default CompVerifPage
